import {Component, OnInit} from '@angular/core';
import {
  ApplicantControllerService, ApplicantIdentity,
  ApplicantIdentityResponseRequest,
  ApplicantRequest, ApplicationLogDetailsRequest, ApplicationLogStepRequest, Log, Step
} from "leia-api";
import {FacadeService} from "../../service-facade/facade.service";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {DocumentsRequest, SocureControllerService} from "skyhopper-api";
import {SocureProcessFlow} from "../../model/socure-process-flow";
import {SocureApplicantStatus} from "../../model/socure-applicant-status";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import {SocureStatus} from "../../model/socure-status";
import {UtilitiesService} from "../../services/utilities.service";
import {ReferenceCode} from "../../../process/models/referenceCode";
import {ERROR_PATH} from "../../constants";
import {ProcessService} from "../../../process/process.service";
import {CoreService} from "../../services/core.service";
import OnboardingSourceEnum = ApplicationLogStepRequest.OnboardingSourceEnum;
import StateEnum = Step.StateEnum;
import NameEnum = Step.NameEnum;
import ServiceTypeEnum = ApplicantIdentityResponseRequest.ServiceTypeEnum;
import OnboardingStepEnum = ApplicationLogStepRequest.OnboardingStepEnum;
import OnboardingStateEnum = ApplicationLogStepRequest.OnboardingStateEnum;

@Component({
  selector: 'app-socure-webhooks',
  templateUrl: './socure-webhooks.component.html',
  styleUrls: ['./socure-webhooks.component.css']
})
export class SocureWebhooksComponent implements OnInit {

  secureSessionId: string = "";
  applicantRequests: ApplicantRequest[] = new Array();
  socureIdPlusKey: string = "";
  activeTabIndex: number = 0;
  socureStatusRefreshIntervalMap: Map<number, any> = new Map<number, any>();

  socureApplicantStatusMap: Map<number, SocureApplicantStatus> = new Map<number, SocureApplicantStatus>();
  applicantIdentityResponseIdMap: Map<number, number> = new Map<number, number>();

  constructor(private facadeService: FacadeService,
              private socureControllerService: SocureControllerService,
              private applicantControllerService: ApplicantControllerService,
              private utilitiesService: UtilitiesService,
              private processService: ProcessService,
              private coreService: CoreService,
              private sanitizer: DomSanitizer) {
    this.secureSessionId = this.facadeService.getShoppingCartApplicationLogsRequest().sessionId!;
    this.socureIdPlusKey = this.facadeService.getStorageItem("socureSubAccountIdPlusKey");
  }

  ngOnInit(): void {
    let isActiveIndexSet = false;

    this.facadeService.getShoppingCartApplicationLogsRequest().applicants?.forEach(async (applicant, index) => {
      if (!applicant.isKyc) {
        return;
      }

      this.applicantRequests.push(applicant);

      let type = this.facadeService.getShoppingCartOnboardingRequest().applicants.find(applicantTemp => applicantTemp.applicantId === applicant.applicantId)?.applicantType;
      const applicantType = type === 'P' ? 'Primary Applicant' : 'Co-Applicant'

      let socureApplicantStatus: SocureApplicantStatus = new SocureApplicantStatus(applicant.applicantId!, "", "", "");

      let documentsRequest: DocumentsRequest = {} as DocumentsRequest;
      let currentStatus: string = "";

      documentsRequest.applicantId = applicant.applicantId;
      documentsRequest.verificationLevel = SocureProcessFlow.UploadOnly;

      const applicantIdentity = await this.applicantControllerService.getRecentApplicantIdentityResponseByServiceTypeId(applicant.applicantId!, ServiceTypeEnum.Socure).toPromise();
      let applicantBypass = false;

      if (applicantIdentity.token && applicantIdentity.outcome === SocureStatus.SessionComplete && !isActiveIndexSet) {
        applicantBypass = true;

        socureApplicantStatus.status = applicantIdentity.outcome;
        socureApplicantStatus.qrCode = "";
        socureApplicantStatus.eventId = applicantIdentity.eventId!;

        this.socureApplicantStatusMap.set(applicant.applicantId!, socureApplicantStatus);
        if (index === 0) {
          this.activeTabIndex = 1;
        } else {
          this.activeTabIndex = 0;
        }
        isActiveIndexSet = true;
        this.processService.triggerSocureDocumentProcessComplete();
      }
      if (!applicantBypass) {

        this.socureControllerService.documentRequest(this.socureIdPlusKey, documentsRequest).subscribe(value => {
          socureApplicantStatus.status = value.data?.status!;
          socureApplicantStatus.qrCode = value.data?.qrcode!;
          socureApplicantStatus.eventId = value.data?.eventId!;

          this.socureApplicantStatusMap.set(applicant.applicantId!, socureApplicantStatus);

          let applicantIdentityResponseRequest: ApplicantIdentityResponseRequest = new ApplicantIdentityResponseRequest();

          applicantIdentityResponseRequest.applicantId = applicant.applicantId;
          applicantIdentityResponseRequest.serviceType = ServiceTypeEnum.Socure;
          applicantIdentityResponseRequest.eventId = value.data?.eventId;

          this.facadeService.createNewApplicantIdentityResponse(applicantIdentityResponseRequest).subscribe(applicantIdentityResponseId => {
            this.applicantIdentityResponseIdMap.set(applicant.applicantId!, applicantIdentityResponseId);
          });
          let socureStatusRefreshInterval = setInterval(() => {
            try {
              this.applicantControllerService.getRecentApplicantIdentityResponseByServiceTypeId(applicant.applicantId!, ServiceTypeEnum.Socure).subscribe(applicantIdentityResponse => {
                if (currentStatus !== applicantIdentityResponse.outcome) {
                  currentStatus = applicantIdentityResponse.outcome!;

                  this.processSocureCallback(applicantIdentityResponse, currentStatus, applicantType, applicant);
                }
              });
            } catch (e) {
              console.warn('Socure Webhooks Status Update - Session Expired.');
              clearInterval(this.socureStatusRefreshIntervalMap.get(applicant.applicantId!));
            }
          }, 5000); // Interval = 5 seconds.
          this.socureStatusRefreshIntervalMap.set(applicant.applicantId!, socureStatusRefreshInterval);
        });

      }
    });
  }

  async processSocureCallback(applicantIdentityResponse: ApplicantIdentity, status: string, applicantType: string, applicant: ApplicantRequest) {
    if (applicantIdentityResponse.outcome !== null && applicantIdentityResponse !== status) {
      if (this.socureApplicantStatusMap.has(applicant.applicantId!)) {
        let socureApplicantStatus = this.socureApplicantStatusMap.get(applicant.applicantId!);
        socureApplicantStatus!.status = status;
        this.socureApplicantStatusMap.set(applicant.applicantId!, socureApplicantStatus!);
      }
      status = applicantIdentityResponse.outcome!.trim();
      let documentUuid: string = applicantIdentityResponse.token!;

      //  Socure session has Expired and we have not yet received a 'Session Complete' callback.
      if (status === SocureStatus.SessionExpired || status === SocureStatus.SdkInitializeError) {
        clearInterval(this.socureStatusRefreshIntervalMap.get(applicant.applicantId!));

        this.facadeService.processOnboardingError(ReferenceCode.SocureFailure).subscribe(() => {
          this.coreService.navigate(`/${ERROR_PATH}`);
        });
      } else if (status === SocureStatus.SessionComplete) {
        if (applicantIdentityResponse.token == null || applicantIdentityResponse.token == undefined || applicantIdentityResponse.token.trim() == '') {
          let applicationRequest = this.facadeService.getShoppingCartApplicationLogsRequest();

          let logs: Log[] = [];
          let applicationLogDetailsRequests: ApplicationLogDetailsRequest[] = [];

          logs.push(this.utilitiesService.createLog("BB8", 'Applicant: ' + applicant.firstName + ' ' + applicant.lastName + ', Socure Document Identifier not provided.'));
          applicationLogDetailsRequests.push(this.utilitiesService.createApplicationLogDetailsRequest(OnboardingSourceEnum.Bb8, 'Applicant: ' + applicant.firstName + ' ' + applicant.lastName + ', Socure Document Identifier not provided.'));

          applicationRequest.step = this.utilitiesService.createApplicantStep(NameEnum.SocureDocumentUpload, applicant.applicantId!, StateEnum.Fail, logs);
          applicationRequest.applicationLogDetailsRequestList = applicationLogDetailsRequests;

          //Fix to capture RC code for DocVFailure
          //write to application_log_step & application_log_details
          const logDetails = Object.assign([], applicationLogDetailsRequests);
          applicationRequest.rcCode = ReferenceCode.DocVFailure;
          applicationRequest.applicationLogStepRequest = this.utilitiesService.createEntireApplicationLogStepRequest(OnboardingStepEnum.SocureDocumentUpload, OnboardingStateEnum.Fail, OnboardingSourceEnum.Bb8, applicant.applicantId!, applicationRequest.rcCode, logDetails);

          this.facadeService.setShoppingCartApplicationLogsRequest(applicationRequest);

          await this.facadeService.updateApplication();

          this.facadeService.processOnboardingError(ReferenceCode.DocVFailure).subscribe(() => {
            this.coreService.navigate(`/${ERROR_PATH}`);
          });
        } else {
          this.processService.socureDocumentUuIdMap.set(applicant.applicantId!, documentUuid);

          clearInterval(this.socureStatusRefreshIntervalMap.get(applicant.applicantId!));

          if (this.activeTabIndex === 0) {
            this.activeTabIndex = 1;
          } else if (this.activeTabIndex === 1) {
            this.activeTabIndex = 0;
          }

          this.processService.triggerSocureDocumentProcessComplete();
        }
      }
    }
  }

  socureTabChange(changeEvent: MatTabChangeEvent) {
    this.activeTabIndex = changeEvent.index;
  }

  sanitizeImageUrl(imageUrl: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }
}
